class Loader {
  constructor(components, logger) {
    this.logger = logger;
    this.components = new Map(Object.entries(components));
  }
  async discover(root, startObserver = false) {
    var _a;
    const [tags, unknownTags] = this.findTagsToRegister(root);
    const tagsToRegister = [...new Set(tags)];
    const results = await Promise.allSettled(tagsToRegister.map((tagName) => this.register(tagName)));
    results.filter((result) => result.status === "rejected").map((result) => result.reason.message).forEach((message) => {
      var _a2;
      (_a2 = this.logger) == null ? void 0 : _a2.warn(`Component Loader warning: ${message}`);
    });
    if (unknownTags.length) {
      (_a = this.logger) == null ? void 0 : _a.warn(
        `Component Loader warning, the following custom tags are not registered: ${unknownTags.join(", ")}`
      );
    }
    if (startObserver) {
      this.start();
    }
  }
  start() {
    if (!this.observer) {
      this.observer = new MutationObserver((mutations) => {
        for (const { addedNodes } of mutations) {
          for (const node of Array.from(addedNodes)) {
            if (node.nodeType === Node.ELEMENT_NODE) {
              this.discover(node);
            }
          }
        }
      });
    }
    this.observer.observe(document.documentElement, { subtree: true, childList: true });
  }
  stop() {
    var _a;
    (_a = this.observer) == null ? void 0 : _a.disconnect();
  }
  // get list of components that can be registered and a list that are unknown
  findTagsToRegister(root) {
    return [root, ...root.querySelectorAll(":not(:defined)")].map((element) => element.tagName.toLowerCase()).filter((tag) => tag.includes("-")).reduce(
      (result, tag) => {
        result[this.components.has(tag) ? 0 : 1].push(tag);
        return result;
      },
      [[], []]
    );
  }
  async register(tagName) {
    const component = this.components.get(tagName);
    if (!component) {
      return Promise.reject(new Error(`No RegisteredComponent entry for <${tagName}>.`));
    }
    const alreadyRegistered = Boolean(customElements.get(tagName));
    if (alreadyRegistered && !component.force) {
      return Promise.resolve();
    }
    return component.register(tagName).then(() => Promise.resolve()).catch((error) => Promise.reject(new Error(`Unable to register <${tagName}>, ${error}.`)));
  }
}
export {
  Loader
};
//# sourceMappingURL=component-loader.js.map
